<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Configuración de empresa</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="content">
    <ion-list>
      <ion-item v-for="p in propiedadesStr" :key="p">
        <ion-label position="floating">{{p}}</ion-label>
        <ion-input :value="empresa[p]" v-on:ionChange="empresa[p]=$event.detail.value"></ion-input>
      </ion-item>
      <ion-item v-for="p in propiedadesBool" :key="p">
        <ion-label text-wrap>{{p.label}}</ion-label>
        <ion-toggle slot="end" :value="empresa[p.nombre]" v-on:ionChange="empresa[p.nombre]=($event.detail.checked==true)" />
      </ion-item>
    </ion-list>
    <pre v-if="!modoProduccion">{{empresa}}</pre>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="guardar">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>

<script>
import Api from '@/components/Api/Api'
export default {
  name: 'Empresa',
  mounted() {
    this.obtener()
  },
  data() {
    return {
      appName: Api.appName,
      modoProduccion: Api.modoProduccion,
      yo: Api.fetchLocal('cmms.yo') || {},
      empresa: {
        Nombre: '',
        RFC: '',
        calcularCostos: false,
        medirTiemposDeOrdenes: false
      },
      esMovil: Api.esMovil(),
      propiedadesStr: ['Nombre', 'RFC'],
      propiedadesBool: [{
        label: 'Habilitar cálculo de costos',
        nombre: 'calcularCostos'
      }, {
        label: 'Habilitar medición de duración de órdenes',
        nombre: 'medirTiemposDeOrdenes'
      }]
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    async obtener() {
      try {
        let empresa = (await Api.get('empresa'))[0]
        if (empresa && empresa._id)
          this.empresa = empresa
        else throw new Error('No encontrada')
      } catch (e) {
        console.error(e)
        toast("Es necesario configurar la empresa", null, 'danger')
      }
    },
    async guardar() {
      await Api.save('empresa', this.empresa)
      toast("Guardado")
      await Api.wait(1000)
      window.location.reload()
    }
  }
}
</script>
